import {
  ChangeDetectionStrategy,
  Component,
  Input,
  output,
} from '@angular/core';

import {
  TooltipDirective,
  TooltipPosition,
} from '@plugins/client/tooltip/tooltip.directive';

@Component({
  selector: 'plugins-multilanguage-action',
  imports: [TooltipDirective],
  template: `
    <button
      type="button"
      [attr.aria-label]="ariaLabel"
      [pluginsTooltipPosition]="tooltipPosition"
      [pluginsTooltip]="tooltip"
      [disabled]="disabled"
      (click)="clicked.emit()"
    >
      <div class="language-content">
        <ng-content />
      </div>
    </button>
  `,
  styleUrl: './action-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiLanguageActionComponent {
  @Input() ariaLabel: string | undefined = undefined;
  @Input() tooltip = '';
  @Input() tooltipPosition: TooltipPosition = 'right';
  @Input() disabled = true;

  readonly clicked = output();
}
